import { EmpowerTier } from "@brexhq/next/types/brex-api";

export const getEditionMappings = (editionValue: string | undefined) => {
  if (!editionValue) return undefined;
  const edition = editionValue.toUpperCase();
  switch (edition) {
    // we have some legacy values like FREE (now Essentials) and PAID (now Full) that we still
    // use in our backend so we need to include these mappings
    case "ESSENTIALS":
    case "FREE":
      return EmpowerTier.FREE;
    case "ESSENTIALS_V2":
      return EmpowerTier.ESSENTIALS_V2;
    case "PAID":
    case "FULL":
      return EmpowerTier.PAID;
    case "PREMIUM":
      return EmpowerTier.PREMIUM;
    case "P_CARD":
      return EmpowerTier.P_CARD;
    case "ENTERPRISE":
      return EmpowerTier.ENTERPRISE;
    default:
      return undefined;
  }
};
